import { render } from "./Transformation.vue?vue&type=template&id=019df6c6&scoped=true"
import script from "./Transformation.vue?vue&type=script&lang=js"
export * from "./Transformation.vue?vue&type=script&lang=js"

import "./Transformation.vue?vue&type=style&index=0&id=019df6c6&scoped=true&lang=css"

import exportComponent from "/builds/Xpansiv/evo/DataPipeline/DataPipeline.Evolve.Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019df6c6"]])

export default __exports__